<div class="content-header">
  <div>
    <h1>Group Link Management</h1>
  </div>
  <div class="header-actions">
    @if (authStore.canEdit()) {
      @if (clientData) {
        <sdc-button
          variant="secondary"
          [attr.data-cy]="'group-link-private-selling-button'"
          (onClick)="onPrivateSellingClick()">
          <span>
            {{
              clientData.isPrivateSellingEnabled
                ? 'Manage private selling'
                : 'Start private selling'
            }}
          </span>
        </sdc-button>
      }
      <sdc-button
        variant="primary"
        [attr.data-cy]="'group-link-create-button'"
        (onClick)="openModalCreate()">
        Create New Group Link
      </sdc-button>
    }
  </div>
</div>

@if (refreshing) {
  <div class="loading">
    <div class="text-container">
      <div>
        <span>Loading new group links</span>
      </div>
      <div>
        <div class="dot-typing"></div>
      </div>
    </div>
  </div>
}

<gs-table [data]="groupLinksList" [columns]="columns"></gs-table>

<p class="legend">
  Showing {{ groupLinksList.length }} of {{ totalItemsInDb }} total Group Links
</p>
<app-pagination
  [currentPage]="currentPage"
  [totalItemsInDb]="totalItemsInDb"
  [itemsPerPage]="itemsPerPage"
  (pageChanged)="pageChanged($event)"
  #pagination></app-pagination>
